import React from 'react'
import { useField } from 'formik'
import { FormControlLabel, Switch } from '@mui/material'
// import Switch from '../../Switch/Switch'

export function FieldSwitch({ ...props }) {
    const [field, meta] = useField(props)

    return (
        <div className="field-container">
            <FormControlLabel control={<Switch {...props} {...field} checked={field.value} />} label={props.label} />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </div>
    )
}
